module.exports = __webpack_public_path__ + "static/img/deleteIcon.02d321ed.png";